import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../api-base-url.token';

export interface SupportMessage {
  object: string;
  message: string;
  establishment_id?: string;
}

export interface SupportResponse {
  message: string;
  ticket_id?: string;
}

@Injectable({
  providedIn: 'root'
})
export class SupportService {
  private http = inject(HttpClient);
  private base = inject(API_BASE_URL);

  sendMessage(payload: SupportMessage): Observable<SupportResponse> {
    return this.http.post<SupportResponse>(`${this.base}/api/v1/support/messages`, payload);
  }
}